// MIRRORS: panel/components/button/button.tsx — identical copy; edit both, or delete this line on both to declare a deliberate split.
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './button.module.scss';

export type ButtonVariant = 'primary' | 'primaryDark' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  /** Leading icon (inline SVG / emoji). */
  icon?: ReactNode;
}

/**
 * Mockup button set: solid emerald ("Detaya Git", "Bilgileri Güncelle"),
 * deep-green solid ("Hemen Ara"), mint-tinted secondary ("Mesaj Gönder").
 */
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  icon,
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth ? styles.fullWidth : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={classes} {...rest}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
    </button>
  );
}
